<template>
   <div class="cascader-select">
    <div class="collapse">
      <div class="collapse-item" v-for="(item, i) in renderData" :key="i">
        <div class="title">
          <van-checkbox shape="square" v-model="item.checked" @change="toggleAll(i)"
           :class="{'half': item.result<item.children.length && item.result>0}" >
            {{ item.title }}
          </van-checkbox>
          <van-icon name="arrow-down" @click.native="handleExpand(i)" :style="{ transform: `rotate(${item.expand ? '0' : '180'}deg)`}" />
        </div>
        <div class="check-box" :style="{ height: `${item.expand ? (item.children.length*40)+'px' : '0px'}` }">
          <div class="check-group">
            <van-checkbox shape="square" :name="child.value" v-for="(child, c) in item.children" :key="c" 
              v-model="child.checked" @click="clickChild($event, i)">
              <div>{{ child.label }}</div>
              
              <van-popover
                v-model="child.showPopover"
                placement="left"
                trigger="click"
                theme="dark"
              >
              <div class="popover">{{child.description }}</div>
                <template #reference>
                  <van-icon name="question-o"  @click.stop="clickIcon(child)"  v-if="child.description" />
                </template>
              </van-popover>
            </van-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <van-button plain type="info" @click="toPrev">上一步</van-button>
      <van-button type="info" class="btn"  @click="saveData(2)">暂存</van-button>
      <van-button type="info" @click="toNext">下一步</van-button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api/appoint'
import moduleMixins from '@/mixins/moduleMixins'
import componentPushMixins from '@/mixins/componentPushMixins'
import appointMixins from '@/mixins/appointMixins'

import {mapGetters} from 'vuex'
export default {
  name: 'CascaderSelect',
  components: {},
  mixins: [moduleMixins, componentPushMixins,appointMixins],
  props: {},
  data() {
    return {
      renderData: [],
      activeNames: [],
      listData: [],
    }
  },
  watch: {
    // showUnit: {
    //   handler(val) {
    //     if (val) {
    //       this.prevent_back()
    //     } else {
    //       this.remove_back()
    //     }
    //   }
    // }
  },
  computed: {
    ...mapGetters('form', ['getFormData','getSubmitFormConfig','getFormConfigByName']),
    navTitle() {
      return '测绘服务事项'
    }
  },
  methods: {
    toPrev(){
      // this.onClickLeft()
      this.$router.push({name:'CommonFormFinal'})
    },
    saveData(){
      let arr = []
      this.renderData.forEach(el => {
        el.children.forEach(item => {
          if(item.checked) 
          {
            const data= {
              CLSXCode:item.key,
              CLSXName:item.label,
              LXDH:'',
              LXR:'',
              bigClass:el.title,
              chdwmc:'',
              chdwshxydm:'',
              isChecked:item.checked,
              measuringType:'多测合一',
              userId:''
            }
            console.log(el)
            arr.push(data)
          }
        })
      })
      this.$store.commit("form/setFormData", { 'CascaderSelect': arr });
      this.saveTempData('CascaderSelect')
    },
    toNext(){
      let arr = []
      this.renderData.forEach(el => {
        el.children.forEach(item => {
          if(item.checked) 
          {
            const data= {
              CLSXCode:item.key,
              CLSXName:item.label,
              LXDH:'',
              LXR:'',
              bigClass:el.title,
              chdwmc:'',
              chdwshxydm:'',
              isChecked:item.checked,
              measuringType:'多测合一',
              userId:''
            }
            console.log(el)
            arr.push(data)
          }
        })
      })
      if(arr.length==0) {
        this.$toast('至少选择一个测绘事项')
        return
      }
      this.$store.commit("form/setFormData", { 'CascaderSelect': arr });
      this.$router.push({
        name: "ProjectAppointOrgan",
      });
    },
    handleExpand(i) {
      this.renderData[i].expand = !this.renderData[i].expand
    },
    toggleAll(i) {
      let item = this.renderData[i]
      // console.log(i, this.renderData[i].checked)
      item.result = item.checked ? 4 : 0
      item.children.forEach(el => {
        el.checked = item.checked
      })
    },
    clickIcon(child) {
      console.log(child)
      child.showPopover = !child.showPopover
    },
    clickChild(e, i) {
      // let item = JSON.parse(JSON.stringify(this.renderData[i]))
      let item = Object.assign({}, this.renderData[i])
      console.log(e, i, item)
      item.result = 0
      item.children.forEach(el => {
        if(el.checked) item.result += 1
      })
      // if(item.result == item.children.length) {
      //   item.checked = true
      // } else {
      //   console.log(item)
      // }
      item.checked = item.result == item.children.length ? true : false
      this.$set(this.renderData, i, item)
    },
    getItemWithNote() {
      api.getItemWithNote({ xmddszq: '' }).then(res => {
        const clsxData=  this.getFormConfigByName('CascaderSelect').data?.CLSX
        const clsxList =[]
        if(clsxData){
          for(const item of clsxData){
            clsxList.push(item.CLSXCode)
          }
        }
        let data = res.data
        data.orders.forEach((el, i) => {
          let children = data[el]
          children.forEach(child => {
            if(clsxData){
              child.checked = clsxList.includes(child.key)
            }
            child.showPopover = false
          })
          let item = {
            title: el,
            expand: true,
            checked: false,
            result: 0,
            children
          }
          this.renderData.push(item)
          this.activeNames.push(i)
        }) 
      })
    }
  },
  created() {
    // this.listData = this.getOpinionData(2).permission
    this.getItemWithNote()
  },
}
</script>
<style lang="scss" scoped>
.cascader-select {
  position: relative;
  .collapse {
    margin: 20px 16px;
    padding-bottom: 50px;
    &-item {
      margin-bottom: 20px;
      .title {
        box-sizing: border-box;
        width: 100%;
        padding: 10px 16px;
        overflow: hidden;
        color: #323233;
        font-size: 14px;
        line-height: 24px;
        background-color: #fff;
        position: relative;
        i {
          height: 24px;
          font-size: 16px;
          line-height: 24px;
          color: #969799;
          padding: 10px 20px;
          position: absolute;
          top: 0px;
          right: 0px;
          transition: all .3s ease-in-out;
        }
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 16px;
          bottom: 0;
          left: 16px;
          border-bottom: 1px solid #ebedf0;
          transform: scaleY(.5);
        }
        .half {
          position: relative;
          ::v-deep .van-checkbox__icon::after {
            content: ' ';
            width: .6em;
            height: .6em;
            background-color: #1989fa;
            position: absolute;
            top: .2em;
            left: .2em;
          }
        }
      }
      .check-box {
        overflow: hidden;
        transition: height .3s ease-in-out;
        .check-group {
          padding: 12px 16px;
          color: #969799;
          font-size: 14px;
          line-height: 1.5;
          background-color: #fff;
          .van-checkbox {
            margin-bottom: 15px;
            ::v-deep .van-checkbox__label {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              i {
                font-size: 20px;
              }
            }
          }
        }
      }
      
    }
  }
  .btn-group {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    // box-shadow: 0px -5px 5px -5px #ccc;
    border-top: 1px solid #eee;
    .btn {
      padding: 14px 20px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid transparent;
    }
  }
}
.popover{
  border-radius: 5px;
  width: 250px;
  padding: 10px;
  color: #fff;
}
</style>
